import { ReactElement } from 'react'
import { PhotoSizeSelectSmall } from '@mui/icons-material'
import { ToggleButton } from '@ui/actions'
import { coordinateEventName } from '@ui/events'
import { useControlStore, useTapelineStore } from '@editorStores'
import { formatPointerModifier } from 'src/shortcuts/pointerModifiers'

const SelectionControls = (): ReactElement => {
  const isMarqueeSelectionActive = useControlStore(state => state.isMarqueeSelection)
  const isTapelineActive = useTapelineStore(state => state.isActive)
  const selectionModeKey = useControlStore(state => state.selectionModeKey)

  // Disable marquee selection when coordinate input mode is active
  const isCoordinateInputMode = selectionModeKey?.startsWith(coordinateEventName)

  return (
    <ToggleButton
      value="snap"
      size="small"
      hint={`Bereich selektieren. Halten Sie ${formatPointerModifier(
        'marquee',
      )} gedrückt und wählen Sie den Bereich des Modells, den Sie auswählen wollen`}
      selected={isMarqueeSelectionActive}
      disabled={isTapelineActive || isCoordinateInputMode}
      Icon={PhotoSizeSelectSmall}
    />
  )
}

export default SelectionControls
